import { HealthGoals, MASONRY_V2 } from '@highmark-web/highmark-common';
import {
  ActivityStackWidgetV2,
  HEALTH_JOURNEY_NAMESPACE,
  HEALTH_JOURNEY_NODE_TYPES,
  RewardsProgramCardCarouselWidgetV2,
} from '@leagueplatform/health-journey';
import { driver, wsDriver } from '@leagueplatform/masonry';

export const initAppMasonryRegistry = () => {
  wsDriver.nodeRendererRegistry.overrideRenderer(
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITIES_WIDGET,
    HEALTH_JOURNEY_NAMESPACE,
    ActivityStackWidgetV2,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAM_CAROUSEL,
    MASONRY_V2.NAMESPACE_DEFAULT,
    RewardsProgramCardCarouselWidgetV2,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_HEALTH_GOALS,
    MASONRY_V2.NAMESPACE_DEFAULT,
    HealthGoals,
  );
};
